const contents = {
  en: {
    breadcrumbs: {
      versions: "Versions",
      news: "News",
      faq: "FAQ"
    },
    highlightModal: {
      title: "Welcome to",
      buttons: {
        readPatchNotes: "Read Patch Notes"
      }
    },
    versions: {
      userMenuTitle: "Versions"
    }
  },
  pt: {
    breadcrumbs: {
      versions: "Versões",
      news: "Novidades",
      faq: "FAQ"
    },
    highlightModal: {
      title: "Bem vindo(a) à",
      buttons: {
        readPatchNotes: "Ler notas de versão"
      }
    },
    versions: {
      userMenuTitle: "Versões"
    }
  },
  es: {
    breadcrumbs: {
      versions: "Versiones",
      news: "Nuevo",
      faq: "FAQ"
    },
    highlightModal: {
      title: "Bienvenido a",
      buttons: {
        readPatchNotes: "Leer notas del parche"
      }
    },
    versions: {
      userMenuTitle: "Versiones"
    }
  }
}

export default contents
